<template>
<div>
  <top></top>
    <navMenu></navMenu>
   <div class="inner">
    <!-- <Header></Header> -->
    <!-- <nav-img></nav-img> -->
    <navbar></navbar>
    <div class="main">
      <div class="banner">
        <aside-left class="aside_left"></aside-left>
        <div class="news_main">
          <liuyan-main @shuaxin="getshuaxin"></liuyan-main>
          <div v-if="liuyanshow" class="message-main">
            <message-main
              :booklist="guestbook"
              @shuaxin="getshuaxin"
            ></message-main>
          </div>
          <div v-else>
            <Zanwu></Zanwu>
          </div>
        </div>
        <advertising class="aside_left_two"></advertising>
      </div>
    </div>
    <div class="dingbu">
      <scroll-top></scroll-top>
    </div>
  </div>
</div>
 
</template>

<script>
import top from "@/components/common/top.vue";
import navMenu from "@/components/common/navMenu.vue";
import URL from "../../api/index.js";
// 引入主导航栏区域
import Header from "../../components/space/Header";
// 引入主体背景区域
import NavImg from "../../components/space/NavImg";
// 引入导航栏区域
import Navbar from "../../components/space/Navbar";
// 引入侧边栏区域
import AsideLeft from "../../components/space/Aside";
import Advertising from "../../components/space/advertising";
// 引入右侧主体区域
import LiuyanMain from "../../components/space/LiuyanFabiao";
import MessageMain from "../../components/space/LiuyanMain";
// 引入删除弹框
import scrollTop from "../../components/space/scrollTop";
// 引入返回顶部按钮
import Zanwu from "../../components/common/zanwu";
import axios from "axios";
//暂无数据
export default {
  data() {
    return {
      guestbook: "",
      UserInfo: "",
      getSpaceinfo: "",
      liuyanshow: true,
      pagenum: "10",
      iteminfo: "",
      spaceid: "",
      isstart: "",
    };
  },
  components: {
    top,
    navMenu,
    Header,
    NavImg,
    Navbar,
    AsideLeft,
    Advertising,
    MessageMain,
    scrollTop,
    Zanwu,
    LiuyanMain,
  },
  mounted() {
    localStorage.removeItem("isstart_message");
    this.getRecordRjw(JSON.parse(localStorage.getItem("loginInfo")))
    this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
    this.getSpaceinfo = JSON.parse(window.localStorage.getItem("getSpaceinfo"));
    this.iteminfo = JSON.parse(window.localStorage.getItem("iteminfo"));
    if (this.iteminfo) {
      this.spaceid = this.iteminfo.space_id;
    } else {
      this.spaceid = this.getSpaceinfo.space_id;
    }
    this.getlist(this.pagenum);
  },
  methods: {
    getshuaxin(val) {
      this.getlist(val);
    },
    getlist(e) {
      var that = this;
      var data = {
        token: that.UserInfo.token,
        spaceid: that.spaceid,
        pagenum: e,
      };
      this.$post(URL.getguestbook, data).then((res) => {
        // console.log(res);
        if (res.result) {
          that.guestbook = res.result;
          that.liuyanshow = true;
        } else {
          that.liuyanshow = false;
        }
        // if(that.guestbook.listsum > 0){
        //   that.liuyanshow = true
        // }else{
        //    that.liuyanshow = false
        // }
      });
    },
    //数据上报
    getRecordRjw(hh) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_message",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的留言板",
          data: {
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id:  hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
  },
};
</script>

<style lang="less">
.box {
  padding-top: 20px;
}
.main {
  background-color: #f5f6f8;
  // min-height: 1000px;
  .banner {
    padding: 25px 0;
    margin: 0 auto;
    width: 1200px;
    overflow: hidden;
    .aside_left {
      float: left;
    }
    .news_main {
      float: right;
      width: 877px;
    }
  }
}
.message-main {
  margin-top: 30px;
}
.aside_left_two {
  float: left;
  clear: left;
}
.dingbu {
  position: fixed;
  bottom: 30px;
  right: 30px;
}
.fabiao {
  position: relative;
}
.biao {
  position: absolute;
  top: 70%;
  right: -10px;
  z-index: 3;
}
</style>
